module.exports = __webpack_public_path__ + "media/src/assets/images/booking-details/time-3cba16bdf97fc01d1a40499b5dd71edd.png";